import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
declare var alertifyjs: any;

@Component({
  selector: 'app-bdv-consultas',
  templateUrl: './bdv-consultas.component.html',
  styleUrls: ['./bdv-consultas.component.css']
})
export class BdvConsultasComponent implements OnInit {

  activeTab = 'movimientos';
  loading = false;
  errorMsg = '';

  readonly CUENTAS_BDV = [
    { numero: '01020135750000010841', label: '0108...0841' },
    { numero: '01020235350000607843', label: '0235...7843' },
    { numero: '01020135710000564478', label: '0135...4478' }
  ];

  // Movimientos
  movCuenta = this.CUENTAS_BDV[0].numero;
  movFechaIni = '';
  movFechaFin = '';
  movResultado: any = null;
  movTodos: any[] = [];
  movFiltrados: any[] = [];
  movPage = 1;
  movPageSize = 20;
  movFiltro = '';

  // Saldo
  saldoCuenta = this.CUENTAS_BDV[0].numero;
  saldoResultado: any = null;

  // Buscar Notificacion
  notifMonto: number | null = null;
  notifReferencia = '';
  notifResultado: any = null;

  // Bitacora
  bitFechaInicio = '';
  bitFechaFin = '';
  bitTipo = '';
  bitUsuario = '';
  bitReferencia = '';
  bitPage = 1;
  bitLimit = 20;
  bitResultado: any = null;
  bitTotal = 0;
  bitTotalPages = 0;
  bitDetalleSeleccionado: any = null;

  // Botón de Pagos BP — sub-tabs
  bpSubTab: 'individual' | 'liquidacion' | 'reclamo' = 'individual';

  // BP — Reclamo cliente (búsqueda por cédula/monto/fechas)
  bpFiltroCedulaPagador = '';
  bpFiltroCedulaUsuario = '';
  bpFiltroMonto: number | null = null;
  bpFiltroMontoMin: number | null = null;
  bpFiltroMontoMax: number | null = null;
  bpFiltroFechaDesde = '';
  bpFiltroFechaHasta = '';
  bpBuscando = false;
  bpBusquedaResults: any[] = [];
  bpBusquedaMsg = '';

  // BP — Consulta individual
  bpTxNumber: number | null = null;
  bpResultado: any = null;
  bpVerificacion: any = null;
  bpConsultando = false;
  bpVerificando = false;
  bpRegistrando = false;
  bpRegistroResult: any = null;

  // BP — Liquidación bancaria
  bpArchivoNombre = '';
  bpFilasParsed: any[] = [];
  bpFilasCruzadas: any[] = [];
  bpSeleccionadas = new Set<number>();
  bpCruzando = false;
  bpBulkRegistrando = false;
  bpBulkResultado: any = null;
  bpSimulando = false;
  bpSimulacionResultado: any = null;

  // BP — Detalle de pago existente (modal deslizante — patrón BancoPlazaConsole)
  bpPaymentDetail: any = null;
  bpPaymentDetailOpen = false;
  bpLoadingDetail = false;

  // BP — Historial/bitácora unificado (timeline kredit + gateway)
  bpHistorialOpen = false;
  bpHistorialLoading = false;
  bpHistorial: any = null;  // { timeline, kreditCount, gatewayCount, bdvIdPayment, gatewayError }
  bpHistorialEntryExpanded: any = null;

  constructor(
    public _auth: AuthService,
    private _user: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // El acceso ya lo valida IsProfileGuard en la ruta (RBAC: cobranza.bdv_consultas; legacy: OWNER).
    // Aquí se aplica el mismo criterio que la tarjeta: con RBAC manda el permiso, sin RBAC el perfil OWNER.
    const permitido = this._auth.hasRbac$.getValue()
      ? this._auth.hasPermission('cobranza.bdv_consultas.read')
      : this._auth.IsPermitid(['OWNER']);
    if (!permitido) {
      this.router.navigate(['/console/cobranza']);
      return;
    }

    const hoy = new Date();
    const dd = String(hoy.getDate()).padStart(2, '0');
    const mm = String(hoy.getMonth() + 1).padStart(2, '0');
    const yyyy = hoy.getFullYear();
    const hoyISO = `${yyyy}-${mm}-${dd}`;
    this.movFechaFin = hoyISO;
    this.movFechaIni = `${yyyy}-${mm}-01`;
    this.bitFechaInicio = hoyISO;
    this.bitFechaFin = hoyISO;
  }

  setTab(tab: string) {
    this.activeTab = tab;
    this.errorMsg = '';
  }

  private formatDateBDV(dateStr: string): string {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
  }

  // ==========================================
  // Movimientos
  // ==========================================
  consultarMovimientos = async () => {
    if (!this.movCuenta || !this.movFechaIni || !this.movFechaFin) {
      alertifyjs.error('Cuenta, fecha inicio y fecha fin son requeridos');
      return;
    }

    this.loading = true;
    this.movResultado = null;
    this.movTodos = [];
    this.movFiltrados = [];
    this.movPage = 1;
    this.movFiltro = '';
    this.errorMsg = '';
    try {
      const resp = await this._user.bdvConsultarMovimientos({
        cuenta: this.movCuenta,
        fechaIni: this.formatDateBDV(this.movFechaIni),
        fechaFin: this.formatDateBDV(this.movFechaFin),
        tipoMoneda: 'VES'
      });
      this.movResultado = resp?.data;
      this.movTodos = this.movResultado?.data?.movs || [];
      this.movFiltrados = [...this.movTodos];
    } catch (err: any) {
      this.errorMsg = err?.error?.msg || err?.error?.error || 'Error consultando movimientos. Verifique que el servicio BDV est\u00e9 disponible.';
    } finally {
      this.loading = false;
    }
  };

  filtrarMovimientos() {
    const q = this.movFiltro.toLowerCase().trim();
    this.movPage = 1;
    if (!q) {
      this.movFiltrados = [...this.movTodos];
      return;
    }
    this.movFiltrados = this.movTodos.filter((m: any) =>
      (m.referencia || '').toLowerCase().includes(q) ||
      (m.descripcion || '').toLowerCase().includes(q) ||
      (m.observacion || '').toLowerCase().includes(q) ||
      (m.importe || '').toString().includes(q) ||
      (m.saldo || '').toString().includes(q) ||
      (m.fecha || '').includes(q) ||
      (m.mov || '').toLowerCase().includes(q)
    );
  }

  get movPaginados(): any[] {
    const start = (this.movPage - 1) * this.movPageSize;
    return this.movFiltrados.slice(start, start + this.movPageSize);
  }

  get movTotalPages(): number {
    return Math.ceil(this.movFiltrados.length / this.movPageSize);
  }

  movIrPagina(page: number) {
    if (page >= 1 && page <= this.movTotalPages) {
      this.movPage = page;
    }
  }

  exportarMovimientosXlsx() {
    const header = ['Fecha', 'Tipo', 'Descripcion', 'Referencia', 'Importe', 'Saldo', 'Observacion'];
    let csv = header.join(';') + '\n';

    this.movFiltrados.forEach((m: any) => {
      const row = [
        m.fecha || '',
        m.mov || '',
        (m.descripcion || '').replace(/;/g, ','),
        m.referencia || '',
        `="${m.importe || ''}"`,
        `="${m.saldo || ''}"`,
        (m.observacion || '').replace(/;/g, ',')
      ];
      csv += row.join(';') + '\n';
    });

    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `movimientos_${this.movCuenta}_${this.movFechaIni}_${this.movFechaFin}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  exportarMovimientosPdf() {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    let html = `<html><head><title>Movimientos BDV - ${this.movCuenta}</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; padding: 20px; }
        h2 { margin-bottom: 5px; }
        .info { color: #666; margin-bottom: 15px; font-size: 11px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #333; color: #fff; padding: 6px 8px; text-align: left; font-size: 11px; }
        td { padding: 5px 8px; border-bottom: 1px solid #ddd; font-size: 11px; }
        .credito { color: #198754; }
        .debito { color: #dc3545; }
        .right { text-align: right; }
      </style></head><body>
      <h2>Estado de Cuenta - Banco de Venezuela</h2>
      <div class="info">Cuenta: ${this.movCuenta} | Periodo: ${this.formatDateBDV(this.movFechaIni)} al ${this.formatDateBDV(this.movFechaFin)} | ${this.movFiltrados.length} movimientos</div>
      <table>
        <thead><tr><th>Fecha</th><th>Descripci&oacute;n</th><th>Referencia</th><th class="right">Importe</th><th class="right">Saldo</th></tr></thead>
        <tbody>`;

    this.movFiltrados.forEach((m: any) => {
      const cls = m.mov === 'CREDITO' ? 'credito' : 'debito';
      html += `<tr>
        <td>${m.fecha}</td>
        <td>${m.descripcion || m.mov}${m.observacion ? '<br><small style="color:#999">' + m.observacion + '</small>' : ''}</td>
        <td>${m.referencia || ''}</td>
        <td class="right ${cls}">${m.mov === 'CREDITO' ? '+' : ''}${m.importe}</td>
        <td class="right">${m.saldo}</td>
      </tr>`;
    });

    html += '</tbody></table></body></html>';
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.print();
  }

  // ==========================================
  // Saldo
  // ==========================================
  consultarSaldo = async () => {
    if (!this.saldoCuenta) {
      alertifyjs.error('N\u00famero de cuenta es requerido');
      return;
    }

    this.loading = true;
    this.saldoResultado = null;
    this.errorMsg = '';
    try {
      const resp = await this._user.bdvConsultarSaldo({
        currency: 'VES',
        account: this.saldoCuenta
      });
      this.saldoResultado = resp?.data;
    } catch (err: any) {
      this.errorMsg = err?.error?.msg || err?.error?.error || 'Error consultando saldo. Verifique que el servicio BDV est\u00e9 disponible.';
    } finally {
      this.loading = false;
    }
  };

  // ==========================================
  // Buscar Notificacion
  // ==========================================
  buscarNotificacion = async () => {
    if (!this.notifMonto || !this.notifReferencia) {
      alertifyjs.error('Monto y referencia son requeridos');
      return;
    }

    this.loading = true;
    this.notifResultado = null;
    this.errorMsg = '';
    try {
      const resp = await this._user.bdvBuscarNotificacion({
        monto: this.notifMonto,
        referencia: this.notifReferencia
      });
      this.notifResultado = resp?.data;
    } catch (err: any) {
      this.errorMsg = err?.error?.msg || err?.error?.error || 'Error buscando notificaci\u00f3n. Verifique que el servicio est\u00e9 disponible.';
    } finally {
      this.loading = false;
    }
  };

  // ==========================================
  // Bitacora
  // ==========================================
  consultarBitacora = async (page?: number) => {
    if (page) this.bitPage = page;

    this.loading = true;
    this.bitDetalleSeleccionado = null;
    this.errorMsg = '';
    try {
      const body: any = { page: this.bitPage, limit: this.bitLimit };
      if (this.bitFechaInicio) body.fechaInicio = this.bitFechaInicio;
      if (this.bitFechaFin) body.fechaFin = this.bitFechaFin;
      if (this.bitTipo) body.tipo_consulta = this.bitTipo;
      if (this.bitUsuario) body.usuario_nombre = this.bitUsuario;
      if (this.bitReferencia) body.referencia = this.bitReferencia;

      const resp = await this._user.bdvConsultarBitacora(body);
      this.bitResultado = resp?.data;
      this.bitTotal = resp?.total || 0;
      this.bitTotalPages = resp?.totalPages || 0;
    } catch (err: any) {
      this.errorMsg = err?.error?.msg || err?.error?.error || 'Error consultando bit\u00e1cora.';
    } finally {
      this.loading = false;
    }
  };

  verDetalle(registro: any) {
    this.bitDetalleSeleccionado = this.bitDetalleSeleccionado === registro ? null : registro;
  }

  getTipoLabel(tipo: string): string {
    const labels: any = {
      movimientos: 'Movimientos',
      saldo: 'Saldo',
      buscar_notificacion: 'Buscar Notificaci\u00f3n'
    };
    return labels[tipo] || tipo;
  }

  // ==========================================
  // Botón de Pagos BP — sub-tabs
  // ==========================================
  setBpSubTab(tab: 'individual' | 'liquidacion' | 'reclamo') {
    this.bpSubTab = tab;
    this.errorMsg = '';
  }

  // Map de status → badge class + label amigable
  bpStatusBadge(status: string): { cls: string; label: string } {
    const map: any = {
      COMPLETE: { cls: 'text-bg-success', label: 'Conciliado' },
      PENDING: { cls: 'text-bg-warning', label: 'Pendiente' },
      TRASH: { cls: 'text-bg-secondary', label: 'Intento descartado' },
      NOT_FOUND: { cls: 'text-bg-danger', label: 'No encontrado' },
      ALREADY_PAID: { cls: 'text-bg-success', label: 'Pago ya registrado' },
      ALREADY_PAID_ORPHAN_REPAIRED: { cls: 'text-bg-success', label: 'Pago existente (reparado)' },
      CORRUPTED_STATE: { cls: 'text-bg-danger', label: 'Estado inconsistente' },
      SKIP_CONCURRENT: { cls: 'text-bg-info', label: 'Otra sesión procesando' },
      DOUBLE_CREATE_DETECTED: { cls: 'text-bg-danger', label: 'Doble creación detectada' },
      OK_CREATED_NEEDS_REVIEW: { cls: 'text-bg-warning', label: 'Creado — requiere revisión' },
      DRY_RUN: { cls: 'text-bg-info', label: 'Simulación' },
      INVALID_INPUT: { cls: 'text-bg-secondary', label: 'Entrada inválida' },
      OK_RECONCILED: { cls: 'text-bg-success', label: 'Pago creado y conciliado' },
      OK_NO_INVOICES: { cls: 'text-bg-success', label: 'Pago creado (sin conciliar)' },
      SKIP_NOT_FOUND: { cls: 'text-bg-danger', label: 'No encontrado' },
      SKIP_BANK_REJECTED: { cls: 'text-bg-danger', label: 'Banco rechazó' },
      SKIP_NOT_EXECUTED: { cls: 'text-bg-secondary', label: 'Usuario abandonó' },
      SKIP_BANK_NO_INFO: { cls: 'text-bg-info', label: 'Banco sin info (reintentar)' },
      SKIP_NO_RATE: { cls: 'text-bg-danger', label: 'Sin tasa' },
      SKIP_NO_PERSON: { cls: 'text-bg-danger', label: 'Sin cliente' },
      SKIP_INVALID_PAYMENT_METHOD: { cls: 'text-bg-danger', label: 'Método inválido' },
      ERROR: { cls: 'text-bg-danger', label: 'Error' }
    };
    return map[status] || { cls: 'text-bg-secondary', label: status || '-' };
  }

  // ——— Consulta individual ———
  bpVerificacionError: string = '';

  // Dispara en paralelo la consulta local (mongo kredit) y la consulta al banco
  // (vía gateway readonly /transaction-readonly) para que el ejecutivo vea ambas
  // vistas de una sola vez. La consulta al banco NO muta la BD del gateway.
  bpConsultarTx = async () => {
    if (!this.bpTxNumber) {
      alertifyjs.error('Ingresa un número de referencia');
      return;
    }
    this.bpConsultando = true;
    this.bpVerificando = true;
    this.bpResultado = null;
    this.bpVerificacion = null;
    this.bpVerificacionError = '';
    this.bpRegistroResult = null;
    this.errorMsg = '';
    try {
      const [kreditResp, bankResp] = await Promise.all([
        this._user.bdvBPConsultarTx(this.bpTxNumber)
          .catch((err: any) => ({ __error: err?.error?.msg || 'Error consultando kredit' })),
        this._user.bdvBPVerificarBanco(this.bpTxNumber)
          .catch((err: any) => ({ __error: err?.error?.msg || err?.message || 'Error consultando banco' }))
      ]);

      if ((kreditResp as any)?.__error) {
        this.errorMsg = (kreditResp as any).__error;
      } else {
        this.bpResultado = (kreditResp as any)?.results?.[0] || null;
      }

      if (!(bankResp as any)?.__error) {
        const d = (bankResp as any)?.data;
        this.bpVerificacion =
          d?.payment?.bdb_finish_response
          || d?.data?.payment?.bdb_finish_response
          || d;
      } else {
        console.warn('[bpConsultarTx] banco no responde:', (bankResp as any).__error);
        this.bpVerificacionError = (bankResp as any).__error;
      }
    } finally {
      this.bpConsultando = false;
      this.bpVerificando = false;
    }
  };

  bpVerificarBanco = async () => {
    if (!this.bpTxNumber) return;
    this.bpVerificando = true;
    try {
      const resp: any = await this._user.bdvBPVerificarBanco(this.bpTxNumber);
      // El gateway devuelve 2 shapes:
      //  - PaymentAccepted → transaction doc plano con .payment.bdb_finish_response
      //  - PaymentRejected/BankNoInfo/PaymentNotExecuted → {data: {payment: {bdb_finish_response: {...}}}}
      // Kredit-api envuelve con {ok, data}. Probamos ambos niveles.
      const d = resp?.data;
      this.bpVerificacion =
        d?.payment?.bdb_finish_response        // PaymentAccepted path
        || d?.data?.payment?.bdb_finish_response  // Rejected / NoInfo / NotExecuted path
        || d;
      console.log('[bpVerificarBanco] parsed', this.bpVerificacion);

      // Mostrar resultado — el ejecutivo decide si descartar con el botón en el HTML
      const r = this.bpVerificacion?.result;
      console.log('[bpVerificarBanco] bank result =', r);
    } catch (err: any) {
      alertifyjs.error(err?.error?.msg || 'Error verificando con el banco');
    } finally {
      this.bpVerificando = false;
    }
  };

  bpDescartando = false;

  // Descartar con confirmación del ejecutivo cuando el banco dice que no hubo débito.
  bpDescartarTxManual = async () => {
    if (!this.bpTxNumber || this.bpDescartando) return;
    const bankResult = this.bpVerificacion?.result || 'UNKNOWN';
    this.bpDescartando = true;
    try {
      const reason = this.bpVerificacion?.msg || this.bpVerificacion?.responseDescription || `Descartado por ejecutivo (${bankResult})`;
      const resp: any = await this._user.bdvBPDescartarTx(this.bpTxNumber, reason, bankResult);
      if (resp?.ok) {
        alertifyjs.success(resp.alreadyTrash
          ? 'Transacción ya estaba descartada'
          : 'Transacción movida a TRASH');
        await this.bpConsultarTx();
      }
    } catch (err: any) {
      console.error('[bpDescartarTxManual]', err);
      alertifyjs.warning('No se pudo descartar. Revisa el historial.');
    } finally {
      this.bpDescartando = false;
    }
  };

  // Estado del modal de confirmación custom (reemplaza alertify.confirm)
  bpConfirmOpen = false;
  bpConfirmUserEmail = '';

  bpCrearPago = () => {
    console.log('[bpCrearPago] click', { tx: this.bpTxNumber, verif: this.bpVerificacion?.result, payment: this.bpResultado?.payment });
    if (!this.bpTxNumber) {
      alertifyjs.error('No hay número de transacción');
      return;
    }
    if (this.bpRegistrando) return;
    this.bpConfirmUserEmail = this._auth?.sessionUser?.email || 'usuario actual';
    this.bpConfirmOpen = true;
  };

  bpCerrarConfirm = () => {
    this.bpConfirmOpen = false;
  };

  bpConfirmarYRegistrar = async () => {
    this.bpConfirmOpen = false;
    if (this.bpRegistrando) return;
    const ok = async () => {
        this.bpRegistrando = true;
        try {
          const resp: any = await this._user.bdvBPRegistrarPagos([this.bpTxNumber!]);
          const r = resp?.results?.[0];
          this.bpRegistroResult = r;
          if (r?.status === 'OK_RECONCILED' || r?.status === 'OK_NO_INVOICES') {
            alertifyjs.success('Pago creado correctamente');
            await this.bpConsultarTx();
          } else if (r?.status === 'ALREADY_PAID' || r?.status === 'ALREADY_PAID_ORPHAN_REPAIRED') {
            alertifyjs.warning(r?.status === 'ALREADY_PAID_ORPHAN_REPAIRED' ? 'El pago ya existía (link reparado) — abriendo detalle' : 'El pago ya existía — abriendo detalle');
            if (r.paymentCode && this.bpResultado?.personCode) {
              this.bpOpenPaymentDetail(r.paymentCode, this.bpResultado.personCode);
            } else {
              await this.bpConsultarTx();
            }
          } else if (r?.status === 'SKIP_CONCURRENT') {
            // Puede ser: (a) lock activo de otra sesión, o (b) la tx ya pasó a COMPLETE.
            // Recargar el estado: si está COMPLETE con payment, tratar como ALREADY_PAID.
            alertifyjs.warning('Verificando estado de la transacción...');
            await this.bpConsultarTx();
            if (this.bpResultado?.status === 'COMPLETE' && this.bpResultado?.payment?.code) {
              alertifyjs.success('El pago ya fue registrado — abriendo detalle');
              if (this.bpResultado.personCode) {
                this.bpOpenPaymentDetail(this.bpResultado.payment.code, this.bpResultado.personCode);
              }
            } else {
              alertifyjs.warning('Otra sesión está procesando esta transacción. Esperá 1-2 min e intentá de nuevo.');
            }
          } else {
            alertifyjs.warning(`Resultado: ${this.bpStatusBadge(r?.status).label}`);
          }
        } catch (err: any) {
          alertifyjs.error(err?.error?.msg || 'Error creando pago');
        } finally {
          this.bpRegistrando = false;
        }
    };
    await ok();
  };

  bpOpenPaymentDetail = async (paymentCode: string, personCode: string) => {
    if (!paymentCode || !personCode) {
      alertifyjs.error('No se puede cargar el detalle: falta código de pago o cliente');
      return;
    }
    this.bpLoadingDetail = true;
    this.bpPaymentDetailOpen = true;
    try {
      const resp: any = await this._user.getPaymentByCode(paymentCode, personCode);
      const list = resp?.res || (Array.isArray(resp) ? resp : null);
      this.bpPaymentDetail = list?.[0] || null;
      if (!this.bpPaymentDetail) {
        alertifyjs.error('No se encontró el detalle del pago');
        this.bpPaymentDetailOpen = false;
      }
    } catch (err: any) {
      alertifyjs.error('No se pudo cargar el detalle del pago');
      this.bpPaymentDetailOpen = false;
    } finally {
      this.bpLoadingDetail = false;
    }
  };

  bpClosePaymentDetail() {
    this.bpPaymentDetailOpen = false;
    this.bpPaymentDetail = null;
  }

  // ——— Historial/bitácora unificado ———
  bpVerHistorial = async () => {
    if (!this.bpTxNumber) return;
    this.bpHistorialLoading = true;
    this.bpHistorialOpen = true;
    this.bpHistorial = null;
    this.bpHistorialEntryExpanded = null;
    try {
      const resp: any = await this._user.bdvBPConsultarBitacora(this.bpTxNumber);
      this.bpHistorial = resp;
    } catch (err: any) {
      alertifyjs.error(err?.error?.msg || 'Error cargando historial');
      this.bpHistorialOpen = false;
    } finally {
      this.bpHistorialLoading = false;
    }
  };

  bpCloseHistorial() {
    this.bpHistorialOpen = false;
    this.bpHistorial = null;
    this.bpHistorialEntryExpanded = null;
  }

  bpToggleHistorialEntry(entry: any) {
    this.bpHistorialEntryExpanded = this.bpHistorialEntryExpanded === entry ? null : entry;
  }

  bpCopyToClipboard(value: string, label: string = 'Valor') {
    if (!value) return;
    try {
      navigator.clipboard.writeText(value);
      alertifyjs.success(`${label} copiada: ${value}`);
    } catch (_) {
      alertifyjs.error('No se pudo copiar');
    }
  }

  // Etiqueta amigable para una entrada de bitácora según endpoint + source
  bpHistorialLabel(entry: any): string {
    const ep = (entry?.endpoint || '').toLowerCase();
    if (ep.includes('init-transaction') || ep.includes('start_payment')) return 'Generación de pago';
    if (ep.includes('send-token') || ep.includes('send_token')) return 'Envío de token SMS';
    if (ep.includes('process')) return 'Procesamiento de pago';
    if (ep.includes('status') || ep.includes('payments/')) return 'Consulta al banco';
    if (ep.includes('transaction')) return 'Consulta de transacción';
    if (ep.includes('registrar-pagos')) return 'Registro desde consola';
    return entry?.source === 'gateway' ? 'Llamada al banco' : 'Operación';
  }

  // ——— Reclamo cliente: búsqueda por filtros ———
  bpBuscarReclamo = async () => {
    const filtro: any = {};
    if (this.bpFiltroCedulaPagador) filtro.cedulaPagador = this.bpFiltroCedulaPagador.trim();
    if (this.bpFiltroCedulaUsuario) filtro.cedulaUsuario = this.bpFiltroCedulaUsuario.trim();
    if (this.bpFiltroMonto != null) filtro.monto = this.bpFiltroMonto;
    if (this.bpFiltroMontoMin != null) filtro.montoMin = this.bpFiltroMontoMin;
    if (this.bpFiltroMontoMax != null) filtro.montoMax = this.bpFiltroMontoMax;
    if (this.bpFiltroFechaDesde) filtro.fechaDesde = this.bpFiltroFechaDesde;
    if (this.bpFiltroFechaHasta) filtro.fechaHasta = this.bpFiltroFechaHasta;

    if (!filtro.cedulaPagador && !filtro.cedulaUsuario && !(filtro.fechaDesde && filtro.fechaHasta)) {
      alertifyjs.warning('Ingresa al menos cédula pagador, cédula titular, o un rango de fechas.');
      return;
    }

    this.bpBuscando = true;
    this.bpBusquedaResults = [];
    this.bpBusquedaMsg = '';
    try {
      const resp: any = await this._user.bdvBPBuscarFiltro(filtro);
      this.bpBusquedaResults = resp?.results || [];
      if (resp?.msg) this.bpBusquedaMsg = resp.msg;
    } catch (err: any) {
      alertifyjs.error(err?.error?.msg || 'Error buscando transacciones');
    } finally {
      this.bpBuscando = false;
    }
  };

  bpSeleccionarDeReclamo(txNum: number) {
    this.bpTxNumber = txNum;
    this.setBpSubTab('individual');
    this.bpConsultarTx();
  }

  bpLimpiarReclamo() {
    this.bpFiltroCedulaPagador = '';
    this.bpFiltroCedulaUsuario = '';
    this.bpFiltroMonto = null;
    this.bpFiltroMontoMin = null;
    this.bpFiltroMontoMax = null;
    this.bpFiltroFechaDesde = '';
    this.bpFiltroFechaHasta = '';
    this.bpBusquedaResults = [];
    this.bpBusquedaMsg = '';
  }

  // Extrae el resultado real del banco de una bitácora, aunque el HTTP haya sido 200.
  // El banco puede devolver 200 con responseCode != 0 o result: 'PaymentRejected'.
  bpBankResult(entry: any): string | null {
    if (!entry) return null;
    const r =
      entry?.information?.result
      || entry?.responseBodyIntegration?.response?.result
      || entry?.responseBodyIntegration?.data?.result
      || entry?.responseBodyIntegration?.result
      || entry?.responseBody?.response?.result
      || entry?.responseBody?.payment?.bdb_finish_response?.result
      || null;
    if (r) return r;
    const code = entry?.responseBodyIntegration?.response?.responseCode
              ?? entry?.responseBodyIntegration?.responseCode
              ?? entry?.responseBody?.response?.responseCode;
    if (code === 0) return 'OK';
    if (typeof code === 'number' && code !== 0) return 'REJECTED';
    return null;
  }

  bpBankResultLabel(entry: any): string {
    const r = this.bpBankResult(entry);
    if (!r) return '';
    const map: any = {
      'PaymentAccepted': 'APROBADO',
      'PaymentRejected': 'RECHAZADO',
      'PaymentNotExecuted': 'ABANDONADO',
      'BankNoInfo': 'SIN INFO',
      'NoValidTransaction': 'TX INVÁLIDA',
      'OK': 'OK',
      'REJECTED': 'RECHAZADO'
    };
    return map[r] || r;
  }

  bpHistorialStatusClass(entry: any): string {
    // Prioridad 1: resultado del banco si lo detectamos
    const bankResult = this.bpBankResult(entry);
    if (bankResult === 'PaymentAccepted' || bankResult === 'OK') return 'text-bg-success';
    if (bankResult === 'PaymentRejected' || bankResult === 'REJECTED') return 'text-bg-danger';
    if (bankResult === 'PaymentNotExecuted') return 'text-bg-warning';
    if (bankResult === 'BankNoInfo' || bankResult === 'NoValidTransaction') return 'text-bg-secondary';

    // Fallback: HTTP status
    const s = entry?.statusResponse;
    if (!s) return 'text-bg-secondary';
    if (s >= 200 && s < 300) return 'text-bg-info';
    if (s >= 400 && s < 500) return 'text-bg-warning';
    if (s >= 500) return 'text-bg-danger';
    return 'text-bg-info';
  }

  // ——— Liquidación bancaria ———
  bpOnArchivoSeleccionado = (event: any) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    this.bpArchivoNombre = file.name;
    this.bpFilasParsed = [];
    this.bpFilasCruzadas = [];
    this.bpSeleccionadas.clear();
    this.bpBulkResultado = null;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });

        // Validación dura de columna
        const hasReferencia = rows.length > 0 && 'Referencia Afiliado' in rows[0];
        if (!hasReferencia) {
          alertifyjs.error('Formato no reconocido — verifica que es el archivo de liquidación BDV (debe tener columna "Referencia Afiliado")');
          this.bpArchivoNombre = '';
          return;
        }

        this.bpFilasParsed = rows.map((row: any) => ({
          transactionNumber: parseInt(row['Referencia Afiliado']),
          paymentIdBdv: row['ID. Transaccion'] || '',
          bankTxId: row['Nro. Transaccion'] || '',
          cedula: row['Cedula Pagador'] || '',
          monto: parseFloat(String(row['Monto Bs.'] || row['Monto'] || 0).toString().replace(',', '.')),
          fecha: row['Fecha'] || '',
          authCode: row['Cod. Autorizacion'] || ''
        })).filter((r: any) => r.transactionNumber);

        if (!this.bpFilasParsed.length) {
          alertifyjs.warning('El archivo no contiene filas válidas');
        }
      } catch (err: any) {
        alertifyjs.error('Error leyendo el archivo: ' + (err.message || err));
        this.bpArchivoNombre = '';
      }
    };
    reader.readAsBinaryString(file);
  };

  bpCruzarConKredit = async () => {
    if (!this.bpFilasParsed.length) return;
    this.bpCruzando = true;
    try {
      const nums = this.bpFilasParsed.map(f => f.transactionNumber);
      const resp: any = await this._user.bdvBPConsultarBatch(nums);
      this.bpFilasCruzadas = this.bpFilasParsed.map(fila => {
        const kredit = (resp?.results || []).find((r: any) => r.transactionNumber === fila.transactionNumber);
        return { ...fila, kredit: kredit || { status: 'NOT_FOUND' } };
      });
    } catch (err: any) {
      alertifyjs.error(err?.error?.msg || 'Error cruzando datos con el sistema');
    } finally {
      this.bpCruzando = false;
    }
  };

  bpToggleSeleccion(txNum: number) {
    if (this.bpSeleccionadas.has(txNum)) {
      this.bpSeleccionadas.delete(txNum);
    } else {
      this.bpSeleccionadas.add(txNum);
    }
  }

  bpIsSeleccionable(kredit: any): boolean {
    return kredit?.status === 'PENDING';
  }

  bpSeleccionarPendientes() {
    for (const f of this.bpFilasCruzadas) {
      if (this.bpIsSeleccionable(f.kredit)) this.bpSeleccionadas.add(f.transactionNumber);
    }
  }

  bpDeseleccionarTodos() {
    this.bpSeleccionadas.clear();
  }

  bpResumenCruzado(): { conciliados: number; pendientes: number; noEncontrados: number; otros: number } {
    const out = { conciliados: 0, pendientes: 0, noEncontrados: 0, otros: 0 };
    for (const f of this.bpFilasCruzadas) {
      const s = f.kredit?.status;
      if (s === 'COMPLETE') out.conciliados++;
      else if (s === 'PENDING') out.pendientes++;
      else if (s === 'NOT_FOUND') out.noEncontrados++;
      else out.otros++;
    }
    return out;
  }

  bpSimularSeleccionados = async () => {
    const nums = Array.from(this.bpSeleccionadas);
    if (!nums.length) {
      alertifyjs.warning('No hay transacciones seleccionadas');
      return;
    }
    this.bpSimulando = true;
    this.bpSimulacionResultado = null;
    try {
      const resp: any = await this._user.bdvBPSimularRegistro(nums);
      this.bpSimulacionResultado = resp;
      const listos = (resp?.results || []).filter((r: any) => r.status === 'DRY_RUN').length;
      alertifyjs.success(`Simulación completa: ${listos}/${nums.length} listas para crear`);
    } catch (err: any) {
      alertifyjs.error(err?.error?.msg || 'Error simulando registro');
    } finally {
      this.bpSimulando = false;
    }
  };

  bpCrearPagosSeleccionados = () => {
    const nums = Array.from(this.bpSeleccionadas);
    if (!nums.length) {
      alertifyjs.warning('No hay transacciones seleccionadas');
      return;
    }
    const userEmail = this._auth?.sessionUser?.email || 'usuario actual';
    alertifyjs.confirm(
      'Crear Pagos en Producción',
      `¿Registrar ${nums.length} pago(s)? Operación registrada como <b>${userEmail}</b>. Esto escribe en la base de datos de PRODUCCIÓN.`,
      async () => {
        this.bpBulkRegistrando = true;
        try {
          const resp: any = await this._user.bdvBPRegistrarPagos(nums);
          this.bpBulkResultado = resp;
          const ok = (resp?.results || []).filter((r: any) => r.status?.startsWith('OK_') || r.status === 'ALREADY_PAID' || r.status === 'ALREADY_PAID_ORPHAN_REPAIRED').length;
          alertifyjs.success(`${ok}/${nums.length} pagos procesados exitosamente`);
          await this.bpCruzarConKredit();
          this.bpSeleccionadas.clear();
        } catch (err: any) {
          alertifyjs.error(err?.error?.msg || 'Error creando pagos');
        } finally {
          this.bpBulkRegistrando = false;
        }
      },
      () => {}
    );
  };
}
